module.exports = __webpack_public_path__ + "img/knps-logo.810254d4.svg";